// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function useIsGuestCustomer() {
  let paymentMethodList = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let customerPaymentMethods = match.customerPaymentMethods;
  return React.useMemo(() => {
    if (typeof paymentMethodList !== "object") {
      return true;
    }
    if (paymentMethodList.TAG !== "Loaded") {
      return true;
    }
    let pList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapperFromClientList(Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList._0));
    let guestCustomerValue = pList.isGuestCustomer;
    if (Core__Option.isNone(guestCustomerValue)) {
      if (typeof customerPaymentMethods !== "object") {
        return true;
      } else if (customerPaymentMethods.TAG === "LoadedSavedCards") {
        return customerPaymentMethods._1;
      } else {
        return customerPaymentMethods._0;
      }
    } else {
      return Core__Option.getOr(guestCustomerValue, true);
    }
  }, [
    paymentMethodList,
    customerPaymentMethods
  ]);
}

function useHandlePostMessages(complete, empty, paymentType, savedMethodOpt, enabledOpt) {
  let savedMethod = savedMethodOpt !== undefined ? savedMethodOpt : false;
  let enabled = enabledOpt !== undefined ? enabledOpt : true;
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let iframeId = match.iframeId;
  React.useEffect(() => {
    if (enabled) {
      Utils$OrcaPaymentPage.handlePostMessageEvents(iframeId, complete, empty, paymentType, loggerState, savedMethod);
    }
  }, [
    complete,
    empty,
    paymentType,
    savedMethod,
    enabled
  ]);
}

function useIsCustomerAcceptanceRequired(displaySavedPaymentMethodsCheckbox, isSaveCardsChecked, isGuestCustomer) {
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  return React.useMemo(() => {
    if (displaySavedPaymentMethodsCheckbox) {
      if (isSaveCardsChecked) {
        return true;
      } else {
        return paymentMethodListValue.payment_type === "SETUP_MANDATE";
      }
    } else {
      return !(isGuestCustomer || paymentMethodListValue.payment_type === "NORMAL");
    }
  }, [
    isSaveCardsChecked,
    paymentMethodListValue.payment_type,
    isGuestCustomer,
    displaySavedPaymentMethodsCheckbox
  ]);
}

function useSendEventsToParent(eventsToSendToParent) {
  React.useEffect(() => {
    let handle = ev => {
      let eventDataObject = ev.data;
      let eventsDict = Utils$OrcaPaymentPage.getDictFromJson(eventDataObject);
      let events = Object.keys(eventsDict);
      let shouldSendToParent = events.some(event => eventsToSendToParent.includes(event));
      if (shouldSendToParent) {
        return Utils$OrcaPaymentPage.messageParentWindow(undefined, Object.entries(eventsDict));
      }
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
}

function useUpdateRedirectionFlags() {
  let setRedirectionFlags = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  return paymentOptions => {
    let topRedirection = Core__Option.flatMap(paymentOptions["shouldUseTopRedirection"], Core__JSON.Decode.bool);
    let removeBeforeUnloadEvents = Core__Option.flatMap(paymentOptions["shouldRemoveBeforeUnloadEvents"], Core__JSON.Decode.bool);
    setRedirectionFlags(cv => ({
      shouldUseTopRedirection: Core__Option.getOr(topRedirection, cv.shouldUseTopRedirection),
      shouldRemoveBeforeUnloadEvents: Core__Option.getOr(removeBeforeUnloadEvents, cv.shouldRemoveBeforeUnloadEvents)
    }));
  };
}

export {
  useIsGuestCustomer,
  useHandlePostMessages,
  useIsCustomerAcceptanceRequired,
  useSendEventsToParent,
  useUpdateRedirectionFlags,
}
/* jotai Not a pure module */
